/** 用户档位 / 配额方案中文名 */
export const USER_PLAN_LABELS = {
  BETA_FREE: '内测免费版',
  FREE: '免费版',
  PRO: '专业版',
  PRO_PLUS: '专业版 Plus',
  TEAM: '团队版',
};

export const QUOTA_PLAN_LABELS = {
  FREE: '免费版',
  PRO: '专业版',
  PRO_PLUS: '专业版 Plus',
  TEAM: '团队版',
};

export function planLabel(planCode) {
  if (!planCode) return '—';
  return USER_PLAN_LABELS[planCode] || QUOTA_PLAN_LABELS[planCode] || planCode;
}
